<template>
  <ul class="pagination component">
    <li><button class="nav-btn first" @click="goToPage(0)" :disabled="isDisabledPrevBtn">
      <UiBaseIcon iconName="left_from_line" height="18" width="18" />
    </button></li>
    <li><button class="nav-btn previous" @click="goToPage(current - 1)" :disabled="isDisabledPrevBtn">
      <UiBaseIcon iconName="chevron_left" height="18" width="18" />
    </button></li>

    <li v-for="page in visiblePagesArray" :key="page">
      <button
        @click="goToPage(page)"
        :disabled="current === page"
        :class="{ 'active': current === page }"
        class="item">
        {{ page + 1 }}
      </button>
    </li>

    <li><button class="nav-btn next" @click="goToPage(current + 1)" :disabled="isDisabledNextBtn">
      <UiBaseIcon iconName="chevron_right" height="18" width="18" />
    </button></li>
    <li><button class="nav-btn last" @click="goToPage(pagesCount - 1)" :disabled="isDisabledNextBtn">
      <UiBaseIcon iconName="right_from_line" height="18" width="18" />
    </button></li>
  </ul>
</template>

<script>
/**
 * @description Component compatibility developed with pagination that starts from 0 page
 */
import UiBaseIcon from '@/components/icons/UiBaseIcon'
export default {
  name: 'Pagination',
  props: {
    page: {
      type: Number,
      default: 1,
      required: true
    },
    total: {
      type: Number,
      default: 0,
      required: true
    },
    limit: {
      type: Number,
      default: 0,
      required: true
    },
    /**
     * max count of pages button
     */
    maxPages: {
      type: Number,
      default: 10
    }
  },

  components: {
    UiBaseIcon
  },

  data () {
    return {
      current: this.page
    }
  },

  watch: {
    page: function (news, old) {
      this.current = news
    }
  },

  methods: {
    goToPage (pageNumber) {
      if ((pageNumber < 0) || (pageNumber > this.pagesCount)) return
      this.current = pageNumber
      this.$emit('getDataTable', this.current + 1)
    }
  },

  computed: {
    pagesCount () { // divide total to limit
      // if haven't remainder
      if ((this.total % this.limit) === 0) return this.total / this.limit
      // if have remainder
      return parseInt(this.total / this.limit) + 1
    },
    pagesArray () {
      return Array.from(new Array(this.pagesCount)).map((item, key) => (item = key))
    },
    visiblePagesArray () {
      return this.pagesArray.slice(this.visiblePagesArrayFirstIndex, this.visiblePagesArrayLastIndex)
    },
    visiblePagesArrayFirstIndex () {
      const pagesArrayLengthMinusMaxPages = this.pagesArray.length - this.maxPages
      if ((this.current >= pagesArrayLengthMinusMaxPages) && (pagesArrayLengthMinusMaxPages > 0)) {
        return pagesArrayLengthMinusMaxPages
      } else if (pagesArrayLengthMinusMaxPages < 0) {
        return 0
      }
      return this.current
    },
    visiblePagesArrayLastIndex () {
      const pagesArrayLengthMinusMaxPages = this.pagesArray.length - this.maxPages
      if (this.current >= pagesArrayLengthMinusMaxPages) {
        return this.pagesArray.length
      }
      return this.current + this.maxPages
    },
    isDisabledNextBtn () {
      return this.current === this.pagesCount - 1
    },
    isDisabledPrevBtn () {
      return !this.current
    }
  }
}
</script>

<style lang="scss" scoped>
.pagination.component{
  display: flex;
  align-items: center;
  justify-content: space-between;
  li {
    button {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 40px;
      height: 40px;
      cursor: pointer;
      margin: 6.5px;
      font-size: 15px;
      border: none;
      color: $color-black-50;
      &:hover {
        color: $color-gray-500;
        border: none;
      }
      &:disabled {
        cursor: not-allowed;
        opacity: .5;
      }
    }
    .active {
      color: #FFFFFF;
      cursor: context-menu;
      pointer-events: none;
      background-color: var(--primary-color);
      border-radius: 5px;
      opacity: 1 !important;
    }
  }
  .info {
    margin-left: 10px;
  }
}
</style>
